<template>
  <div ref="treeView" data-i="all" class="tree card" :style="{ height }"
    :class="{'context-menu-enable': hasContextMenu, 'tree-check': radio || check, 'tree-outer-border': showOuterBorder}">
    <div v-if="hasFilter" class="tree-search mb-4">
      <div class="icon-btn icon-btn-right">
        <b-form-input maxlength="100" v-model="treeSearchKeyword" @input="filterTree" :placeholder="this.holder"
          :title="this.holder" />
        <a v-if="treeSearchKeyword != ''"
          class="icon-right icon btn btn-sm btn-icon btn-circle btn-icon-primary btn-active-light-primary"
          @click="removeTreeSearchKeyword()">
          <i class="bi bi-x-circle fs-3"></i>
        </a>
      </div>
    </div>
    <div class="tree-content" @click="clicked">
      <div v-if="title" class="tree-title">
        <h5 class="mb-0" v-text="$t(title)"></h5>
        <a v-if="!radio && !check" data-i="+" class="btn btn-xs btn-icon btn-circle btn-icon-dark btn-active-secondary"
          :title="$t('추가')">
          <i class="bi bi-plus fs-2"></i>
        </a>
      </div>
      <div class="tree-body d-flex flex-column" :class="{'navbar-nav-scroll': !noScrollbar}" :style="[{'max-height': maxHeight}, {'min-height': minHeight}]">
        <div class="tree-list"></div>
        <div v-if="visibleCount == 0" class="d-flex flex-center p-4" style="margin: auto 0;">
          {{this.$t('목록이 없습니다.')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let treeId = 0;

export default {
  props: {    
    treeId: { default: () => treeId++ },
    labelKey: { default: () => 'label' },
    title: {},
    hasContextMenu: { default: () => false },
    hasRowEvent: { default: () => true },
    hasFilter: { default: () => false },
    filterHolder: { default: () => '' },
    customAction: {},
    expanded: { default: () => true },
    expandDepth: { default: () => 999 },
    size: { default: () => 'md' },
    height: { default: () => 'auto' },
    minHeight: { default: () => 'auto' },
    maxHeight: { default: () => '100%' },
    showOuterBorder: Boolean,
    noScrollbar: Boolean,
    tree: {
      default: () => [{
        label: 'test',
        children: [{ label: 'child1' }, {
          label: 'child2',
          children: [{ label: 'child1' }, {
            label: 'child2',
            children: [{ label: 'child1' }, { label: 'child2' }]
          }]
        }]
      }]
    },
    radio: Boolean, check: Boolean, hideIcon: Boolean, hideSelBg: Boolean,
  },
  data: () => ({
    treeSearchKeyword: '',
    timerTreeKeyword: () => { },
    visibleCount: 0,
    holder: '',
  }),
  async mounted() {
    if (this.filterHolder) this.holder = this.filterHolder;
    this.$refs.treeView.classList.add('tree-' + this.size);
    this.setTree();
  },
  watch: {
    tree: 'setTree'
  },
  methods: {
    setTree() {
      this.treeSearchKeyword = '';
      this.$el.querySelector('.tree-list').innerHTML = this.view(this.tree, [treeId++]);
      this.setVisibleCount();
    },
    procFilterTree() {
      for (const item of this.$refs.treeView.querySelectorAll('.tree-list .item-label')) {
        let result = item.innerHTML.replace(/<em[^>]*>(.*?)<\/em>/gi, '$1');
        item.innerHTML = result;
      }

      const regexp = new RegExp(this.treeSearchKeyword, 'i');
      const regexp2 = new RegExp(`(${this.treeSearchKeyword})`, 'gi');
      const treeItems = this.$refs.treeView.querySelectorAll('.tree-list .item');
      let dataIdxs = [];
      for (const item of treeItems) {
        const labelEl = item.querySelector('.item-label');
        const label = labelEl.innerHTML;
        if (label && regexp.test(label)) {
          item.classList.remove('d-none');
          dataIdxs.push(item.getAttribute('data-i'));
          if (this.treeSearchKeyword) {
            labelEl.innerHTML = label.replace(regexp2, '<em class="keyword-emphasis">$1</em>');
          }
        } else {
          item.classList.add('d-none');
        }
      }
      
      for (const dataIdx of dataIdxs) {
        let parts = dataIdx.split('_');
        for (let i = parts.length - 1; i >= 0; i--) {
          let slicedId = parts.slice(0, i + 1).join('_');
          let parentEl = this.$refs.treeView.querySelector('[data-i="' + slicedId + '"]');
          if (parentEl) { parentEl.classList.remove('d-none', 'closed'); }
        }
      }

      this.setVisibleCount();
    },
    filterTree() {
      clearTimeout(this.timerFileterTree);
      this.timerFileterTree = setTimeout(() => this.procFilterTree(), 500);
    },
    removeTreeSearchKeyword() {
      this.treeSearchKeyword = '';
      this.procFilterTree();
    },
    setVisibleCount() {
      let count = 0;
      try {
        for (const item of this.$refs.treeView.querySelectorAll('.tree-list .item')) {
          if (!item.classList.contains('d-none')) count++;
        }
        this.visibleCount = count;
      } catch (e) {
        this.visibleCount = 0;
      }
    },
    view(items, ids = [], depth = 0) {
      depth = depth + 1;
      const html = [`<ul class="root">`];
      let i = 0;
      for (const item of items) {
        const id = [...ids, i++].join('_');
        const hasChildren = item.children && item.children.length ? true : false;
        let icon = '';
        if (item.icon) {
          icon = `<i class="fs-4 bi ${item.icon}"></i>`;
        } else if (item.icon != false) {
          icon = item.children ? `<i class="fs-4 bi bi-folder-fill text-primary"></i>` : ``;
        }

        html.push(`
          <li class="item-root" depth="${depth}">
            <div data-i="${id}" data-type="${item.type || ''}" data-key="${item.key || ''}" class="item form-check form-check-sm form-check-custom form-check-solid
              ${!this.expanded || (this.expanded && this.expandDepth < depth) ? 'closed' : ''}
              ${item.class ? item.class : ''} ${this.hasRowEvent ? '' : 'row-event-disable'}"
              style="padding-left: ${18 * (depth - 1) + 2}px">
              <span class="item-toggle">
                ${hasChildren ?
                  `<a class="toggle btn btn-xxs btn-icon btn-circle btn-icon-dark btn-active-secondary" data-u="toggle">
                    <i class="bi bi-caret-down-fill fs-8" data-u="toggle"></i>
                  </a>` : ''}
              </span>
              <span class="item-check ${this.radio || this.check ? '' : 'd-none'}">
                ${this.radio ? `<input type="radio" name="tree_${this.treeId}" id="tree_${this.treeId}_${id}" class="form-check-input" />`
            : this.check ? `<input type="checkbox" name="tree_${this.treeId}" id="tree_${this.treeId}_${id}" class="form-check-input" ${item.checked ? ' checked' : ''} />`
              : ''
          }
              </span>
              <label class="item-title" for="tree_${this.treeId}_${id}" title="${item[this.labelKey]}">
                ${icon}
                <span class="item-label">${item[this.labelKey]}</span>
                ${item.pwdExist ? '<i class="bi bi-lock-fill text-primary ms-2"></i>' : ''}
              </label>
              <span class="item-action">
                  ${this.customAction ? this.customAction(item) : ''}
                  <a class="context-menu btn btn-xs btn-icon btn-circle btn-icon-dark btn-active-secondary" title="${this.$t('기능')}" data-u="item-action">
                    <i class="bi bi-three-dots-vertical fs-6" data-u="item-action"></i>
                  </a>
              </span>
            </div>
            ${item.children && item.children.length ? this.view(item.children, id.split('_'), depth) : ''}
          </li>
        `);
      }

      return html.join('') + '</ul>';
    },
    toggleItem(evt) {
      let el = evt.target;
      return el.closest('.item').classList.toggle('closed');
    },
    unfold(type, key) {
      try {
        var el = this.$refs.treeView.querySelector(`[data-type="${type}"][data-key="${key}"]`);
        el.classList.remove('closed');
      } catch(e) {
        console.log(e);
      }
    },
    deselectAll() {
      const treeEls = this.$refs.treeView.querySelectorAll('.tree-list .sel');
      treeEls.forEach(treeEl => {
        treeEl.classList.remove('sel');
      });
    },
    deselectAllMenu() {
      const menuEls = document.querySelectorAll('.menus .sel');
      menuEls.forEach(menuEl => {
        menuEl.classList.remove('sel');
      });
    },
    clicked(evt) {
      this.$store.commit('contextmenu');
      
      let el = evt.target;
      const { target: { dataset: { u } } } = evt;
      
      if (u == 'toggle') {
        return el.closest('.item').classList.toggle('closed');
      } else {
        while (!el.dataset.i) {
          el = el.parentNode;
        }

        const oldEl = document.querySelector('.tree .sel');
        let item = { children: this.tree }, sibling;
        const ids = el.dataset.i.replace(/^_/, '').split('_').slice(1);
        for (const i of ids) item = (sibling = item.children)[i];
        
        if (u == 'item-action') { // 노드 액션
          evt.stopPropagation();
          return el != this.$el && this.$emit('context', { evt, item, sibling });
        } else if (el.dataset.i == '+') { // 노드 추가
          return this.$emit('clicked', { item: null });
        } else if (el.dataset.i == 'all') { // All
          return this.$emit('clicked', { item: {} });
        } else if (u != 'tree_action' && oldEl == el) { // 이미 선택 된 아이템일 경우 패스
          return;
        } else {
          if (oldEl) {
            oldEl.classList.remove('sel');
          }

          if (!this.radio && !this.check && !this.hideSelBg) {
            this.deselectAll();
            this.deselectAllMenu();
            el.classList.add('sel');
          }

          this.$emit('clicked', { item, evt, treeView: this, u: u });
        }
      }
    },
    selectByKey(key) {
      this.deselectAll();
      this.deselectAllMenu();
      let el = this.$refs.treeView.querySelector(`[data-key="${key}"]`);
      if(el) {
        el.classList.add('sel');
      }
    },
  },
}
</script>